






























import { Component, Vue, Watch } from "vue-property-decorator";
import SignUpForm from "@/models/forms/SignUpForm";
import Cognito from "@/cognito/index";
import NotificationMixin from "../../mixins/notification";
import { mixins } from "vue-class-component";
import LoaderMixin from "../../mixins/loader";
import {
  confirmUser,
  login,
  resendCode,
  getUser,
  setCognitoUser
} from "../../services/authentication";

@Component({
  components: {}
})
export default class Confirm extends mixins(NotificationMixin, LoaderMixin) {
  private code: string;
  private user: SignUpForm;
  private valid: boolean = false;

  private loading: boolean = false;
  private counter: number = 30;

  private email = "";

  constructor() {
    super();

    this.code = "";
  }

  private created() {
    this.email = this.$router.currentRoute.query.email as string;

    this.email && setCognitoUser(this.email);
  }

  private confirmUser() {
    // @ts-ignore
    if (this.$refs.form.validate()) {
      this.showLoader();

      confirmUser(this.code)
        .then(() => {
          this.user = JSON.parse(
            this.$localStorage.get("userForm")
          ) as SignUpForm;

          login(this.user.email, this.user.password)
            .then(userSession => {
              this.$store.commit("setUserSession", userSession);
              this.hideLoader();
              this.$router.push("/conta");
              this.showSuccessNotification("Inscrição realizada com sucesso.");
            })
            .catch(err => {
              this.hideLoader();
              this.showServerErorNotification();
            });
        })
        .catch(err => {
          if (err.code === "CodeMismatchException") {
            this.showErrorNotification("PIN inválido ou expirado.");
          } else {
            this.showServerErorNotification();
          }
          this.hideLoader();
        });
    }
  }

  private resendConfirmationCode() {
    resendCode()
      .then(() => this.disableButton())
      .catch(() => {
        this.showServerErorNotification();
      });
  }

  private disableButton() {
    this.loading = !this.loading;

    const interval = setInterval(() => (this.counter -= 1), 1000);

    setTimeout(() => {
      this.loading = false;
      this.counter = 0;
      clearInterval(interval);
    }, 1000 * 30);
  }
}
